import { render, staticRenderFns } from "./wxShre.vue?vue&type=template&id=11815dd8&scoped=true&"
import script from "./wxShre.vue?vue&type=script&lang=js&"
export * from "./wxShre.vue?vue&type=script&lang=js&"
import style0 from "./wxShre.vue?vue&type=style&index=0&id=11815dd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11815dd8",
  null
  
)

export default component.exports